export default function Main(props:any){
    return (<div  className="flex-grow">{props.children}</div>)
}